import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Redireciona para a rota raiz atual quando a entidade ativa muda.
 *
 * @description
 * Este hook realiza as seguintes operações:
 * 1. Observa a entidade padrão ativa na store Redux
 * 2. Guarda a entidade anterior entre renderizações
 * 3. Detecta troca de entidade dentro do mesmo agrupamento de rota
 * 4. Navega para a raiz da rota quando a troca exige reset de contexto
 *
 * @returns {boolean | undefined} Indica se houve redirecionamento por troca de entidade
 */
const useKickBack = () => {
  const defaultEntidadeId = useSelector(
    (store) => store.entidade.current.default_entidade_id
  );

  const previousEntidade = useRef();
  const location = useLocation();
  const navigate = useNavigate();

  const xSplittedPathName = location.pathname.split("/");
  const xRootPathName = `/${xSplittedPathName[1]}`;

  const routeRootRef = useRef(xRootPathName);
  const kick = useRef();

  useEffect(() => {
    if (previousEntidade.current === undefined) {
      kick.current = false;
      previousEntidade.current = defaultEntidadeId;
      return;
    }

    const isNestedRoute = location.pathname.includes(routeRootRef.current);
    const isSameEntidade = previousEntidade.current !== defaultEntidadeId;

    kick.current = isNestedRoute && isSameEntidade;

    if (kick.current) {
      navigate(xRootPathName);
    }

    previousEntidade.current = defaultEntidadeId;
  }, [defaultEntidadeId]);

  return kick.current;
};

export default useKickBack;
